import { render } from "./ColumnsTab.vue?vue&type=template&id=102d68bf&ts=true"
import script from "./ColumnsTab.vue?vue&type=script&lang=ts"
export * from "./ColumnsTab.vue?vue&type=script&lang=ts"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__